import styled from 'styled-components';
import { LabelInput } from './../LabelInput';

export const FormControl = styled.div`
    ${LabelInput} {
        margin-right: 20px;
        vertical-align: top;
    }
`;
